import React from 'react'
import Logo from '../moralis-logo.svg';
import Eth from '../eth.svg';
import { Link } from 'react-router-dom';

function Header(props) {
  const {connect,isConnected,address} = props;   
  return (
    
    <header>
      <div className="leftH">
        <img src={Logo} alt="logo" className='logo' />
        <div className="headerItem" style={{fontWeight: 'bold', fontSize: '18px', marginRight: '20px'}}>Trust DEX</div>
        <Link to="/" className="link">
        <div className="headerItem">Swap</div>
        </Link>
        <Link to="/tokens" className="link">
        <div className="headerItem">Tokens</div>
        </Link>

        </div>
        
      <div className="rightH">
        <div className="headerItem">
        <img src={Eth} alt="eth" className='eth' />
        Ethereum
        </div>
     
      <div className="connectButton" onClick={connect}>
        {isConnected ? address.slice(0, 4) + "..."+address.slice(38) : "Connect "} 
      </div>
      </div>
    </header>
  )
}

export default Header